import { useQuery } from '@apollo/client';
import isNil from 'lodash/isNil';
import { useQueryStates } from 'nuqs';
import { GET_BENCHMARK } from '@/graphql/StatusQuoAnalysis.queries';
import { SEARCH_PARAMS } from '@/routes/search-params';

type Options = {
  // null = no comparison, id = 0 full portfolio, a positive id = a portfolio.
  benchmarkPortfolioId: number | null;
  isBenchmarkActive: boolean;
  skip?: boolean;
};

export const useQueryGetBenchmark = ({ benchmarkPortfolioId, isBenchmarkActive, skip = false }: Options) => {
  const [{ referenceAreaType, emissionFactorSource, classOfUse, typeOfUse }] = useQueryStates(
    SEARCH_PARAMS.statusQuoAnalysis.building,
  );

  const { data, loading, previousData } = useQuery(GET_BENCHMARK, {
    skip: skip || !isBenchmarkActive || isNil(referenceAreaType),
    variables: {
      portfolioId: benchmarkPortfolioId,
      referenceAreaType,
      emissionFactorSource,
      classOfUse,
      typeOfUse,
    },
  });

  return {
    benchmark: isBenchmarkActive ? (data?.getBenchmark ?? previousData?.getBenchmark) : undefined,
    isLoadingBenchmark: loading,
  };
};
